import React from "react";
import { useLocation } from "react-router-dom";
import { PaymentMethod } from "../../types";
import { TotemTerminalPayment } from "./TotemTerminal";
import { PixTotemPayment } from "./PixTotem";
import { usePixEnabledGuard } from "../../hooks/usePixEnabledGuard";

export const ConfirmMarketPurchase: React.FC = () => {
  const {
    state: { paymentMethod },
  }: {
    state: {
      paymentMethod?: PaymentMethod;
    };
  } = useLocation();
  const isPixEnabledOnTotem = usePixEnabledGuard(
    "/market-purchase",
    paymentMethod === PaymentMethod.PIX
  );

  if (
    paymentMethod === PaymentMethod.CREDIT_CARD ||
    paymentMethod === PaymentMethod.DEBIT_CARD
  ) {
    return <TotemTerminalPayment />;
  }
  if (paymentMethod === PaymentMethod.PIX && isPixEnabledOnTotem) {
    return <PixTotemPayment />;
  }
  return <div />;
};
